import React from 'react';
import { Outlet } from 'react-router-dom';
import { ModalProvider } from 'contexts/modal';
import ScrollToTop from 'components/layout/scroll_to_top';

const RootLayout = () => (
  <ModalProvider>
    <ScrollToTop />
    <Outlet />
  </ModalProvider>
);

export default RootLayout;
